import { render, staticRenderFns } from "./ModalJustificativa.vue?vue&type=template&id=32adb9a5"
import script from "./ModalJustificativa.vue?vue&type=script&lang=js"
export * from "./ModalJustificativa.vue?vue&type=script&lang=js"
import style0 from "./ModalJustificativa.vue?vue&type=style&index=0&id=32adb9a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports